import { insertIf, join } from 'lib/helpers';
import styles from './RiveBadge.module.css';

export enum BadgeType {
  Standard,
  Primary,
}

type Props = {
  children: string;
  type?: BadgeType;
};

export default function RiveBadge({
  children,
  type = BadgeType.Primary,
}: Props) {
  return (
    <div
      className={join([
        styles.Badge,
        ...insertIf(type === BadgeType.Primary, styles.BadgePrimary),
        ...insertIf(type === BadgeType.Standard, styles.BadgeStandard),
      ])}
    >
      {children}
    </div>
  );
}
